"use client";

import { useEffect } from "react";
import { track } from "@/lib/analytics";

// Renders nothing. It exists because the article page is a server component
// and the read still has to be counted somewhere: the platform's help-content
// endpoint deliberately does not increment view_count, since its caller is a
// cache that refetches on a timer rather than a reader.
export function TrackHelpArticleView({
  slug,
  collection,
}: {
  slug: string;
  collection: string;
}) {
  useEffect(() => {
    track("help_article_viewed", { slug, collection });
  }, [slug, collection]);

  return null;
}
